<mat-checkbox class="mat-option all-custom-checkbox" [indeterminate]="isIndeterminate()" [checked]="isChecked()" (click)="$event.stopPropagation()"
    (change)="toggleSelection($event)">
    {{text}}
</mat-checkbox>